import type { QueryKey } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useMutate } from '@/shared/hooks/useMutate';
import { useToast } from '@/shared/hooks/useToast';

type UseEntityDeleteArgs<TData> = {
  api: (id: string) => Promise<TData>;
  invalidateKeys?: QueryKey[];
  successKey: string;
  onSuccess?: () => void;
};

export const useEntityDelete = <TData>({
  api,
  invalidateKeys,
  successKey,
  onSuccess,
}: UseEntityDeleteArgs<TData>) => {
  const { t } = useTranslation();
  const toast = useToast();

  return useMutate({
    api,
    invalidateKeys,
    onSuccess: () => {
      toast.info(t(successKey));
      onSuccess?.();
    },
    onError: (_e, message) => toast.error(message),
  });
};
